import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import detectBrowserLanguage from "detect-browser-language";

import { TRANSLATIONS as es } from "./es";
import { TRANSLATIONS as en } from "./en";

import { equalsIgnoringCase } from "../utils/validators";

/**
 * Idiomas soportados.
 * @type {string[]}
 */
const SUPPORTED_LANGS = ["es", "en"];

/**
 * Idioma por defecto cuando el del navegador no está soportado.
 * @type {string}
 */
const DEFAULT_LANGUAGE = "en";

/**
 * Resuelve el idioma inicial leyendo el primario del navegador
 * (`navigator.language`, valor singular preferido por el usuario).
 *
 * Se evita `order: ["navigator"]` del LanguageDetector porque éste
 * itera `navigator.languages` (array) y elige el primer match con
 * `supportedLngs` — en navegadores con `["en-US", "es-ES"]` gana
 * inglés aunque el usuario tenga el español como idioma principal
 * del sistema.
 *
 * @returns {string} Código ISO 639-1 ("es" o "en")
 */
const resolveInitialLanguage = () => {
  const primary = detectBrowserLanguage()?.split("-")[0];
  return SUPPORTED_LANGS.includes(primary) ? primary : DEFAULT_LANGUAGE;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: !equalsIgnoringCase("PRODUCTION", process.env.REACT_APP_ENV),
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    lng: resolveInitialLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGS,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // El idioma se fija arriba vía `lng`; el LanguageDetector queda
      // disponible solo por compatibilidad con `i18n.changeLanguage()`
      // desde la UI (no se usa para detectar al cargar la página).
      order: [],
      caches: [],
    },
    returnObjects: true,
  });

export default i18n;
